import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      id="shopify-section-footer"
      className="shopify-section shopify-section--footer"
    >
      <footer
        id="section-footer"
        data-section-id="footer"
        data-section-type="footer"
        className="Footer "
        role="contentinfo"
      >
        <div className="Container">
          <div className="Footer__Inner">
            <div className="Footer__Block Footer__Block--links">
              <h2 className="Footer__Title u-h6">Meet Bakimball</h2>
              <ul className="Linklist">
                <li className="Linklist__Item">
                  <Link
                    onClick={toTop}
                    to="/about"
                    className="Link Link--primary"
                  >
                    About Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="Footer__Block Footer__Block--links">
              <h2 className="Footer__Title u-h6">Customer Care</h2>
              <ul className="Linklist">
                <li className="Linklist__Item">
                  <Link
                    onClick={toTop}
                    to="/shipping"
                    className="Link Link--primary"
                  >
                    Shipping &amp; Returns
                  </Link>
                </li>
              </ul>
            </div>
            <div className="Footer__Block Footer__Block--links">
              <h2 className="Footer__Title u-h6">Contact Us</h2>
              <ul className="Linklist">
                <li className="Linklist__Item">
                  <Link
                    onClick={toTop}
                    to="/contact"
                    className="Link Link--primary"
                  >
                    Get Help
                  </Link>
                </li>
              </ul>
            </div>

            <div className="Footer__Block Footer__Block--links">
              <h2 className="Footer__Title u-h6">Connect</h2>
              <ul className="Linklist">
                <li className="Linklist__Item">TahReek Battles</li>
                <li className="Linklist__Item">LouisTeresa50477@hotmail.com</li>
                <li className="Linklist__Item">26 Columbia ave</li>
                <li className="Linklist__Item">Newark</li>
                <li className="Linklist__Item">07106</li>
                <li className="Linklist__Item">United States of America</li>
                <li className="Linklist__Item">New Jersey</li>
                <li className="Linklist__Item">Call us:+1 7747442196</li>
              </ul>
            </div>

            <div className="Footer__Block Footer__Block--text">
              <div className="only-desktop">
                <ul className="Footer__Social HorizontalList HorizontalList--spacingLoose">
                  <li className="HorizontalList__Item">
                    <Link
                      onClick={toTop}
                      to="https://www.facebook.com/baublebar/"
                      className="Link Link--primary"
                      target="_blank"
                      rel="noopener"
                      aria-label="Facebook"
                    >
                      <span className="Icon-Wrapper--clickable">
                        <svg
                          className="Icon Icon--facebook "
                          viewBox="0 0 9 17"
                        >
                          <path d="M5.842 17V9.246h2.653l.398-3.023h-3.05v-1.93c0-.874.246-1.47 1.526-1.47H9V.118C8.718.082 7.75 0 6.623 0 4.27 0 2.66 1.408 2.66 3.994v2.23H0v3.022h2.66V17h3.182z" />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li className="HorizontalList__Item">
                    <Link
                      onClick={toTop}
                      to="https://www.instagram.com/baublebar/"
                      className="Link Link--primary"
                      target="_blank"
                      rel="noopener"
                      aria-label="Instagram"
                    >
                      <span className="Icon-Wrapper--clickable">
                        <svg
                          className="Icon Icon--instagram "
                          role="presentation"
                          viewBox="0 0 32 32"
                        >
                          <path d="M15.994 2.886c4.273 0 4.775.019 6.464.095 1.562.07 2.406.33 2.971.552.749.292 1.283.635 1.841 1.194s.908 1.092 1.194 1.841c.216.565.483 1.41.552 2.971.076 1.689.095 2.19.095 6.464s-.019 4.775-.095 6.464c-.07 1.562-.33 2.406-.552 2.971-.292.749-.635 1.283-1.194 1.841s-1.092.908-1.841 1.194c-.565.216-1.41.483-2.971.552-1.689.076-2.19.095-6.464.095s-4.775-.019-6.464-.095c-1.562-.07-2.406-.33-2.971-.552-.749-.292-1.283-.635-1.841-1.194s-.908-1.092-1.194-1.841c-.216-.565-.483-1.41-.552-2.971-.076-1.689-.095-2.19-.095-6.464s.019-4.775.095-6.464c.07-1.562.33-2.406.552-2.971.292-.749.635-1.283 1.194-1.841s1.092-.908 1.841-1.194c.565-.216 1.41-.483 2.971-.552 1.689-.083 2.19-.095 6.464-.095zm0-2.883c-4.343 0-4.889.019-6.597.095-1.702.076-2.864.349-3.879.743-1.054.406-1.943.959-2.832 1.848S1.251 4.473.838 5.521C.444 6.537.171 7.699.095 9.407.019 11.109 0 11.655 0 15.997s.019 4.889.095 6.597c.076 1.702.349 2.864.743 3.886.406 1.054.959 1.943 1.848 2.832s1.784 1.435 2.832 1.848c1.016.394 2.178.667 3.886.743s2.248.095 6.597.095 4.889-.019 6.597-.095c1.702-.076 2.864-.349 3.886-.743 1.054-.406 1.943-.959 2.832-1.848s1.435-1.784 1.848-2.832c.394-1.016.667-2.178.743-3.886s.095-2.248.095-6.597-.019-4.889-.095-6.597c-.076-1.702-.349-2.864-.743-3.886-.406-1.054-.959-1.943-1.848-2.832S27.532 1.247 26.484.834C25.468.44 24.306.167 22.598.091c-1.714-.07-2.26-.089-6.603-.089zm0 7.778c-4.533 0-8.216 3.676-8.216 8.216s3.683 8.216 8.216 8.216 8.216-3.683 8.216-8.216-3.683-8.216-8.216-8.216zm0 13.549c-2.946 0-5.333-2.387-5.333-5.333s2.387-5.333 5.333-5.333 5.333 2.387 5.333 5.333-2.387 5.333-5.333 5.333zM26.451 7.457c0 1.059-.858 1.917-1.917 1.917s-1.917-.858-1.917-1.917c0-1.059.858-1.917 1.917-1.917s1.917.858 1.917 1.917z" />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li className="HorizontalList__Item">
                    <Link
                      onClick={toTop}
                      to="https://www.pinterest.com/baublebar/"
                      className="Link Link--primary"
                      target="_blank"
                      rel="noopener"
                      aria-label="Pinterest"
                    >
                      <span className="Icon-Wrapper--clickable">
                        <svg
                          className="Icon Icon--pinterest "
                          role="presentation"
                          viewBox="0 0 32 32"
                        >
                          <path d="M16 0q3.25 0 6.208 1.271t5.104 3.417 3.417 5.104T32 16q0 4.333-2.146 8.021t-5.833 5.833T16 32q-2.375 0-4.542-.625 1.208-1.958 1.625-3.458l1.125-4.375q.417.792 1.542 1.396t2.375.604q2.5 0 4.479-1.438t3.063-3.937 1.083-5.625q0-3.708-2.854-6.437t-7.271-2.729q-2.708 0-4.958.917T8.042 8.689t-2.104 3.208-.729 3.479q0 2.167.812 3.792t2.438 2.292q.292.125.5.021t.292-.396q.292-1.042.333-1.292.167-.458-.208-.875-1.083-1.208-1.083-3.125 0-3.167 2.188-5.437t5.729-2.271q3.125 0 4.875 1.708t1.75 4.458q0 2.292-.625 4.229t-1.792 3.104-2.667 1.167q-1.25 0-2.042-.917t-.5-2.167q.167-.583.438-1.5t.458-1.563.354-1.396.167-1.25q0-1.042-.542-1.708t-1.583-.667q-1.292 0-2.167 1.188t-.875 2.979q0 .667.104 1.292t.229.917l.125.292q-1.708 7.417-2.083 8.708-.333 1.583-.25 3.708-4.292-1.917-6.938-5.875T0 16Q0 9.375 4.687 4.688T15.999.001z" />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li className="HorizontalList__Item">
                    <Link
                      onClick={toTop}
                      to="https://www.tiktok.com/@baublebar?lang=en"
                      className="Link Link--primary"
                      target="_blank"
                      rel="noopener"
                      aria-label="TikTok"
                    >
                      <span className="Icon-Wrapper--clickable">
                        <svg
                          className="Icon Icon--tiktok "
                          role="presentation"
                          viewBox="0 0 13 16"
                        >
                          <path
                            d="M12.998 6.146A4.055 4.055 0 019.23 4.331v6.245a4.616 4.616 0 11-4.615-4.615c.096 0 .19.008.285.014V8.25c-.095-.012-.188-.029-.285-.029a2.356 2.356 0 000 4.711c1.3 0 2.45-1.025 2.45-2.326L7.089 0h2.176A4.053 4.053 0 0013 3.618v2.528"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="Footer__Aside">
            <div className="Footer__Copyright">
              <div className="Footer__Copyright-Wrapper">
                <div>
                  <Link
                    onClick={toTop}
                    to="/"
                    className="Footer__StoreName Heading u-h7 Link Link--secondary"
                  >
                    © Bakimball
                  </Link>
                  <Link
                    onClick={toTop}
                    to="/privacy"
                    className="Footer__StoreName Heading u-h7 Link Link--secondary"
                  >
                    {" "}
                    Privacy Terms
                  </Link>
                </div>
                <div className="only-mobile">
                  <ul className="Footer__Social HorizontalList HorizontalList--spacingTight">
                    <li className="HorizontalList__Item">
                      <Link
                        onClick={toTop}
                        to="https://www.facebook.com/baublebar/"
                        className="Link Link--primary"
                        target="_blank"
                        rel="noopener"
                        aria-label="Facebook"
                      >
                        <span className="Icon-Wrapper--clickable">
                          <svg
                            className="Icon Icon--facebook "
                            viewBox="0 0 9 17"
                          >
                            <path d="M5.842 17V9.246h2.653l.398-3.023h-3.05v-1.93c0-.874.246-1.47 1.526-1.47H9V.118C8.718.082 7.75 0 6.623 0 4.27 0 2.66 1.408 2.66 3.994v2.23H0v3.022h2.66V17h3.182z" />
                          </svg>
                        </span>
                      </Link>
                    </li>
                    <li className="HorizontalList__Item">
                      <Link
                        onClick={toTop}
                        to="https://www.instagram.com/baublebar/"
                        className="Link Link--primary"
                        target="_blank"
                        rel="noopener"
                        aria-label="Instagram"
                      >
                        <span className="Icon-Wrapper--clickable">
                          <svg
                            className="Icon Icon--instagram "
                            role="presentation"
                            viewBox="0 0 32 32"
                          >
                            <path d="M15.994 2.886c4.273 0 4.775.019 6.464.095 1.562.07 2.406.33 2.971.552.749.292 1.283.635 1.841 1.194s.908 1.092 1.194 1.841c.216.565.483 1.41.552 2.971.076 1.689.095 2.19.095 6.464s-.019 4.775-.095 6.464c-.07 1.562-.33 2.406-.552 2.971-.292.749-.635 1.283-1.194 1.841s-1.092.908-1.841 1.194c-.565.216-1.41.483-2.971.552-1.689.076-2.19.095-6.464.095s-4.775-.019-6.464-.095c-1.562-.07-2.406-.33-2.971-.552-.749-.292-1.283-.635-1.841-1.194s-.908-1.092-1.194-1.841c-.216-.565-.483-1.41-.552-2.971-.076-1.689-.095-2.19-.095-6.464s.019-4.775.095-6.464c.07-1.562.33-2.406.552-2.971.292-.749.635-1.283 1.194-1.841s1.092-.908 1.841-1.194c.565-.216 1.41-.483 2.971-.552 1.689-.083 2.19-.095 6.464-.095zm0-2.883c-4.343 0-4.889.019-6.597.095-1.702.076-2.864.349-3.879.743-1.054.406-1.943.959-2.832 1.848S1.251 4.473.838 5.521C.444 6.537.171 7.699.095 9.407.019 11.109 0 11.655 0 15.997s.019 4.889.095 6.597c.076 1.702.349 2.864.743 3.886.406 1.054.959 1.943 1.848 2.832s1.784 1.435 2.832 1.848c1.016.394 2.178.667 3.886.743s2.248.095 6.597.095 4.889-.019 6.597-.095c1.702-.076 2.864-.349 3.886-.743 1.054-.406 1.943-.959 2.832-1.848s1.435-1.784 1.848-2.832c.394-1.016.667-2.178.743-3.886s.095-2.248.095-6.597-.019-4.889-.095-6.597c-.076-1.702-.349-2.864-.743-3.886-.406-1.054-.959-1.943-1.848-2.832S27.532 1.247 26.484.834C25.468.44 24.306.167 22.598.091c-1.714-.07-2.26-.089-6.603-.089zm0 7.778c-4.533 0-8.216 3.676-8.216 8.216s3.683 8.216 8.216 8.216 8.216-3.683 8.216-8.216-3.683-8.216-8.216-8.216zm0 13.549c-2.946 0-5.333-2.387-5.333-5.333s2.387-5.333 5.333-5.333 5.333 2.387 5.333 5.333-2.387 5.333-5.333 5.333zM26.451 7.457c0 1.059-.858 1.917-1.917 1.917s-1.917-.858-1.917-1.917c0-1.059.858-1.917 1.917-1.917s1.917.858 1.917 1.917z" />
                          </svg>
                        </span>
                      </Link>
                    </li>
                    <li className="HorizontalList__Item">
                      <Link
                        onClick={toTop}
                        to="https://www.pinterest.com/baublebar/"
                        className="Link Link--primary"
                        target="_blank"
                        rel="noopener"
                        aria-label="Pinterest"
                      >
                        <span className="Icon-Wrapper--clickable">
                          <svg
                            className="Icon Icon--pinterest "
                            role="presentation"
                            viewBox="0 0 32 32"
                          >
                            <path d="M16 0q3.25 0 6.208 1.271t5.104 3.417 3.417 5.104T32 16q0 4.333-2.146 8.021t-5.833 5.833T16 32q-2.375 0-4.542-.625 1.208-1.958 1.625-3.458l1.125-4.375q.417.792 1.542 1.396t2.375.604q2.5 0 4.479-1.438t3.063-3.937 1.083-5.625q0-3.708-2.854-6.437t-7.271-2.729q-2.708 0-4.958.917T8.042 8.689t-2.104 3.208-.729 3.479q0 2.167.812 3.792t2.438 2.292q.292.125.5.021t.292-.396q.292-1.042.333-1.292.167-.458-.208-.875-1.083-1.208-1.083-3.125 0-3.167 2.188-5.437t5.729-2.271q3.125 0 4.875 1.708t1.75 4.458q0 2.292-.625 4.229t-1.792 3.104-2.667 1.167q-1.25 0-2.042-.917t-.5-2.167q.167-.583.438-1.5t.458-1.563.354-1.396.167-1.25q0-1.042-.542-1.708t-1.583-.667q-1.292 0-2.167 1.188t-.875 2.979q0 .667.104 1.292t.229.917l.125.292q-1.708 7.417-2.083 8.708-.333 1.583-.25 3.708-4.292-1.917-6.938-5.875T0 16Q0 9.375 4.687 4.688T15.999.001z" />
                          </svg>
                        </span>
                      </Link>
                    </li>
                    <li className="HorizontalList__Item">
                      <Link
                        onClick={toTop}
                        to="https://www.tiktok.com/@baublebar?lang=en"
                        className="Link Link--primary"
                        target="_blank"
                        rel="noopener"
                        aria-label="TikTok"
                      >
                        <span className="Icon-Wrapper--clickable">
                          <svg
                            className="Icon Icon--tiktok "
                            role="presentation"
                            viewBox="0 0 13 16"
                          >
                            <path
                              d="M12.998 6.146A4.055 4.055 0 019.23 4.331v6.245a4.616 4.616 0 11-4.615-4.615c.096 0 .19.008.285.014V8.25c-.095-.012-.188-.029-.285-.029a2.356 2.356 0 000 4.711c1.3 0 2.45-1.025 2.45-2.326L7.089 0h2.176A4.053 4.053 0 0013 3.618v2.528"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n    .Footer {\n      border-top: 1px solid var(--border-color);\n    }\n  ",
        }}
      />
    </div>
  );
}

export default Footer;
